# Setup the global events bus for enhanced modules
class Backbone.Enhanced.Events extends Backbone.Events

module.exports = Backbone.Enhanced.Events